module.exports = __webpack_public_path__ + "media/images/icon_stores-4151509aed6d9be797549946f99dc455.svg";